
import React, { SetStateAction, useState } from 'react'

import AddIcon from '@mui/icons-material/Add';
import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import Typography from '@mui/material/Typography';

import { RecipePresetSubstep, settingsInterface } from '../../../app/recipeCreation/createRecipe.types';
import { BladeIcon, DeleteStepIcon, TempIcon, TimeIcon } from '../../../utils/iconRefs/recipeStepsIcons';
import { temperatureASCII, TIME } from '../utils/constants';
import getSpeed from '../utils/getSpeedText';
import { getTime } from '../utils/getTime';
import { InstructionPopUpMode } from './instruction.types';
import InstructionEditPopup from './instructionEditPopUp';
import styles from "./instructionSettingsCreation.module.css";
import PresetResetDialog from './PresetResetDialog';

const InstructionSettingsCreation = ({ settings, setSettings, isPresetOpen, setIsPresetOpen, setPresetSelected }: {
  setSettings: React.Dispatch<SetStateAction<Array<settingsInterface>>>;
  settings: Array<settingsInterface>; isPresetOpen: boolean;
  setIsPresetOpen: React.Dispatch<SetStateAction<boolean>>; setPresetSelected: React.Dispatch<SetStateAction<RecipePresetSubstep | null>>;
}) => {
  const deleteSetting = (index: number) => {
    setSettings((currentSetting) =>
      currentSetting.filter((_, i) => i !== index)
    );
  };
  const [editPopUpOpen, setEditPopupOpen] = useState(false);
  const [settingsIndexToEdit, setSettingsIndexToEdit] = useState(0);
  const [selectedEditMode, setSelectedEditMode] = useState<string>(TIME);
  const [resetPopUp, setResetPopUp] = useState(false);
  const [instructionModalMode, setInstructionModalMode] = useState<string | null>(null);

  const handleClose = () => {
    setEditPopupOpen(false);
    setSelectedEditMode(TIME);
    setInstructionModalMode(null);
  };
  const onSettingClick = (index: number) => {
    setEditPopupOpen(true);
    setSettingsIndexToEdit(index);
    setInstructionModalMode(InstructionPopUpMode.EDIT);
  };
  const onAddButtonClick = () => {
    setInstructionModalMode(InstructionPopUpMode.ADD)
    setEditPopupOpen(true);
  }
  // ToDo : use Grid instead of Box
  return (
    <>
      <Box className={styles.main_container}>
        <Box className={styles.instruction_title}>
          <Box className={styles.instruction_icon}>
            <BladeIcon />
            <Typography variant="body2paralell">Blade</Typography>
          </Box>
          <Box className={styles.instruction_icon}>
            <TempIcon />
            <Typography variant="body2paralell">Temp</Typography>
          </Box>
          <Box className={styles.instruction_icon}>
            <TimeIcon />
            <Typography variant="body2paralell">Time</Typography>
          </Box>
        </Box>
        {settings.map((setting, index) => (
          <Box className={styles.instruction_display_card}>
            <Box onClick={() => deleteSetting(index)}>
              <DeleteStepIcon />
            </Box>
            <Box
              className={styles.instruction_detail}
              onClick={() => onSettingClick(index)}
            >
              <Typography variant="caption3Light">
                {getSpeed(setting.speed)}
              </Typography>
              <Typography variant="caption3Light">
                {setting.temperature + temperatureASCII}C
              </Typography>
              <Typography variant="caption3Light">
                {getTime(setting.time)}
              </Typography>
            </Box>
          </Box>
        ))}
        <Fab className={styles.create_button_dialog} onClick={onAddButtonClick}>
          <AddIcon />
        </Fab>
        <Typography
          className={styles.preset_typography}
          onClick={() => setResetPopUp(true)}
          variant="caption3Light"
        >
          Go back to presets
        </Typography>
        {editPopUpOpen && <InstructionEditPopup
          editPopUpOpen={editPopUpOpen}
          handleClose={handleClose}
          instructionModalMode={instructionModalMode}
          selectedEditMode={selectedEditMode}
          setInstructionModalMode={setInstructionModalMode}
          setSelectedEditMode={setSelectedEditMode}
          setSettings={setSettings}
          setSettingsIndexToEdit={setSettingsIndexToEdit}
          settings={settings}
          settingsIndexToEdit={settingsIndexToEdit}
        />}

      </Box >
      {resetPopUp &&
        <PresetResetDialog
          resetPopUp={resetPopUp}
          setIsPresetOpen={setIsPresetOpen}
          setPresetSelected={setPresetSelected}
          setResetPopUp={setResetPopUp}
          setSettings={setSettings}
        />
      }

    </>
  )
}

export default InstructionSettingsCreation;